import { useState } from 'react';

import { CaretRightIcon } from '@phosphor-icons/react';
import { AnimatePresence, motion } from 'motion/react';
import { toast } from 'sonner';

export interface AppSidebarOnboardingProps {
  title: string;
  items: {
    id: string;
    label: string;
    icon?: React.ReactNode;
    onClick?: () => void;
  }[];
}

export const AppSidebarOnboarding = ({ title, items }: AppSidebarOnboardingProps) => {
  const [isHidden, setIsHidden] = useState(false);

  return (
    <AnimatePresence initial={false}>
      {!isHidden && (
        <motion.div
          initial={{ opacity: 0, height: 0, scale: 0.98 }}
          animate={{ opacity: 1, height: 'auto', scale: 1 }}
          exit={{ opacity: 0, height: 0, scale: 0.98 }}
          transition={{
            duration: 0.24,
            ease: [0.75, 0.1, 0.8, 1],
          }}
          className="origin-top"
        >
          <div className="relative rounded-xl bg-background-1 p-2 shadow-sm outline outline-input/70">
            {title && (
              <div className="relative flex items-center justify-between px-2 pb-2 text-xs">
                <span className="text-xs font-medium tracking-wider text-foreground-5 uppercase">
                  {title}
                </span>

                <button
                  className="
                    cursor-pointer text-foreground-6 transition-colors duration-250
                    hover:text-foreground-4
                  "
                  onClick={() => {
                    toast.info('You can always access it later in your profile', {
                      position: 'top-center',
                    });
                    setIsHidden(true);
                  }}
                  type="button"
                >
                  Hide
                </button>
              </div>
            )}

            <div className="flex flex-col gap-0 divide-border overflow-hidden rounded-lg shadow-sm">
              {items.map((item) => (
                <button
                  key={item.id}
                  className="
                    group/article flex w-full cursor-pointer items-center bg-background-0 py-2.5
                    ps-3 pe-2 text-left text-gray-900
                  "
                  onClick={item.onClick}
                  type="button"
                >
                  <span
                    className="
                      grow text-sm font-medium
                      group-hover/article:underline
                    "
                  >
                    {item.label}
                  </span>
                  <CaretRightIcon
                    className="
                      size-4 -translate-x-0.5 text-primary transition-transform duration-300
                      group-hover/article:translate-x-0
                    "
                  />
                </button>
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
